import { combineReducers } from "redux";
import { ReportsState, ReportsListTableState } from "./ReportsState";
import { Action, ActionType, SortReportsAction, FilterReportsAction, ToggleGetReportAction, PageReportsAction } from "./ReportActions";
import { administrationReducer } from "./Administration/AdministrationReducer";
import { QueryCondition } from "../misc/api/apiTypes";
import { getQueryFilters, getQuerySorting } from "../misc/components/queryTable/ReducerUtilities";

function filterReportsReduce(state: ReportsListTableState, action: FilterReportsAction): ReportsListTableState {
    const filters = getQueryFilters(state.reportsQuery, action.member, action.condition, action.value);

    return {
        ...state,
        reportsQuery: {
            ...state.reportsQuery,
            Filters: filters,
            Page: {
                ...state.reportsQuery.Page,
                Current: 1,
            }
        },
    };
}

function sortReportsReduce(state: ReportsListTableState, action: SortReportsAction): ReportsListTableState {
    const order = getQuerySorting(state.reportsQuery, action.member);

    return {
        ...state,
        reportsQuery: {
            ...state.reportsQuery,
            Order: order,
        }
    }
}

function pageReportsReduce(state: ReportsListTableState, action: PageReportsAction): ReportsListTableState {
    return {
        ...state,
        reportsQuery: {
            ...state.reportsQuery,
            Page: {
                ...state.reportsQuery.Page,
                Current: action.page,
            }
        },
    };
}

function toggleGetReportReduce(state: ReportsListTableState, action: ToggleGetReportAction): ReportsListTableState {
    const updatedInitData = state.reportsQuery.Data.map(x => {
        if (x.Id !== action.reportId) {
            return x;
        }

        return {
            ...x,
            IsRequestingDownload: action.isRequestingDownload,
        }
    });

    return {
        ...state,
        errorMessage: null,
        reportOpening: !action.isRequestingDownload ? null : state.reportOpening,
        reportsQuery: {
            ...state.reportsQuery,
            Data: updatedInitData,
        }
    }
}

export function listTableReducer(state: ReportsListTableState = null, action: Action): ReportsListTableState {
    switch (action.type) {
        case ActionType.FilterReports:
            return filterReportsReduce(state, action);
        case ActionType.SortReports:
            return sortReportsReduce(state, action);
        case ActionType.PageReports:
            return pageReportsReduce(state, action);
        case ActionType.ToggleGetReport:
            return toggleGetReportReduce(state, action);
        case ActionType.GetReportFailed:
            return {
                ...state,
                reportOpening: null,
                errorMessage: 'Failed downloading the report from the server',
            };
        case ActionType.RequireStudySelection:
            return {
                ...state,
            }
        case ActionType.HideWidgets:
            return {
                ...state,
                hideWidgets: true,
                reportsQuery: {
                    ...state.reportsQuery,
                    Filters: [{
                        Member: "IsWidget",
                        Condition: QueryCondition.Equal,
                        Values: ["False"]
                    }],
                }
            }
        case ActionType.ToggleReportModal:
            return {
                ...state,
                selectedReportId: action.id,
                showReportModal : !state.showReportModal
            }
        default:
            return state;
    }
}

export default combineReducers<ReportsState>({ listTable: listTableReducer, administration: administrationReducer });
